import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const NursingRoomIcon = ({ color = 'currentColor', width = 160, height = 160, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 160 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M55.041 75.0082H104.962V135.537C104.962 137.949 103.006 139.905 100.594 139.905H59.4091C56.9966 139.905 55.041 137.949 55.041 135.537V75.0082Z"
                stroke={color}
                strokeWidth="6"
            />
            <path
                d="M114.945 70.2578C114.945 72.6703 112.989 74.6259 110.577 74.6259H49.4237C47.0113 74.6259 45.0557 72.6703 45.0557 70.2578V62.8657C45.0557 60.4532 47.0113 58.4976 49.4237 58.4976H110.577C112.989 58.4976 114.945 60.4532 114.945 62.8657V70.2578Z"
                stroke={color}
                strokeWidth="6"
            />
            <path
                d="M89.7165 37.0199C93.8093 39.2415 104.55 46.2577 104.181 58.4972L55.815 58.4906C55.4454 46.2544 66.1835 39.2382 70.2798 37.0131V31.4168C70.2798 25.5891 74.4828 20.6832 79.6472 20.4806H79.7323H80.2635H80.3491C85.5135 20.6865 89.7165 25.5925 89.7165 31.4235V37.0199Z"
                stroke={color}
                strokeWidth="6"
            />
            <path d="M94.9763 89.9849H84.9922" stroke={color} strokeWidth="6" strokeLinecap="round" />
            <path d="M94.9763 104.96H84.9922" stroke={color} strokeWidth="6" strokeLinecap="round" />
            <path d="M94.9763 119.938H84.9922" stroke={color} strokeWidth="6" strokeLinecap="round" />
        </svg>
    );
};
